module.exports = __webpack_public_path__ + "img/hr-dirt-1.48aabc78.png";